(() => {
  const mobileProductVideo = window.matchMedia('(max-width: 749px)');

  const positionProductVideos = (scope = document) => {
    scope.querySelectorAll('.section-main-product').forEach((section) => {
      const video = section.querySelector('[data-ef-product-video]');
      const title = section.querySelector('.product-info-title');
      const description = section.querySelector(
        '.ef-pdp-details .ef-pdp-description, .product-info-description',
      );
      const home = section.querySelector('.ef-pdp-video-home');
      if (!video || !title || !home) return;

      if (mobileProductVideo.matches) {
        if (description) {
          description.insertAdjacentElement('afterend', video);
        } else {
          title.insertAdjacentElement('afterend', video);
        }
      } else {
        home.insertAdjacentElement('afterend', video);
      }

      const sku = section.querySelector('.product-info-sku');
      if (sku && !sku.querySelector('.ef-card-video-button--pdp-sku, .ef-pdp-watch-video')) {
        sku.classList.add('ef-pdp-sku-row');
        const watchButton = document.createElement('button');
        watchButton.type = 'button';
        watchButton.className = 'ef-pdp-watch-video';
        watchButton.innerHTML = '<span aria-hidden="true">▶</span><strong>Watch video</strong>';
        watchButton.addEventListener('click', () => {
          video.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const nativeVideo = video.querySelector('video');
          if (nativeVideo) nativeVideo.play().catch(() => {});
        });
        sku.append(watchButton);
      }
    });
  };

  positionProductVideos();
  mobileProductVideo.addEventListener('change', () => positionProductVideos());

  const bars = document.querySelectorAll('[data-ef-mobile-buy]');

  bars.forEach((bar) => {
    const proxy = bar.querySelector('[data-ef-submit-proxy]');
    if (!proxy) return;
    proxy.addEventListener('click', () => {
      const section = bar.closest('.section-main-product');
      const submit = section && section.querySelector('.product-info-buy-buttons .add-cart-button:not([disabled])');
      if (submit) submit.click();
    });

    if (globalThis.webvista && globalThis.PUB_SUB_EVENTS) {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event.data || event.data.sectionId !== bar.dataset.sectionId || !event.data.html) return;
        const sourceBar = event.data.html.querySelector('[data-ef-mobile-buy]');
        if (!sourceBar) return;
        const sourcePrice = sourceBar.querySelector('strong');
        const price = bar.querySelector('strong');
        if (sourcePrice && price) price.textContent = sourcePrice.textContent;
        const sourceButton = sourceBar.querySelector('[data-ef-submit-proxy]');
        if (sourceButton) proxy.disabled = sourceButton.disabled;
        proxy.textContent = proxy.disabled ? 'Sold out' : 'Add to cart';
      });
    }
  });

  document.addEventListener('shopify:section:load', () => {
    positionProductVideos();
    document.querySelectorAll('[data-ef-mobile-buy] [data-ef-submit-proxy]').forEach((proxy) => {
      proxy.disabled = !document.querySelector('.product-info-buy-buttons .add-cart-button:not([disabled])');
    });
  });
})();
